const angular = require('angular');
const _ = require('lodash');

/**
 * Toolbox for adding controls into view.
 * 
 * @export
 * @class ToolboxComponent
 */
export class ToolboxComponent {

  /**
   * 
   * 
   * @type {*}
   * @memberOf ToolboxComponent
   */
  models: any; //HTML element models
  templateComponents:any;
  /**
   * 
   * 
   * @type {*}
   * @memberOf ToolboxComponent
   */
  store: any; //Localstorage instance
  /**
   * 
   * 
   * @type {string}
   * @memberOf ToolboxComponent
   */
  searchText: string;
  Util: any;
  selectedView: any;
  counter = {};
  counterService: any;
  selectedType :string;
  showsection:any;
  opendialog:any;
  /**
   * Creates an instance of ToolboxComponent.
   * 
   * @param {any} localStorage
   * 
   * @memberOf ToolboxComponent
   */
  constructor(localStorage, Util, counterService) {
    this.store = localStorage;
    this.models = angular.copy(this.store.get('components'));
    this.templateComponents = angular.copy(this.store.get('templates'));
    this.selectedView = this.store.get('selectedView');
    this.counter = counterService.counter;
    this.selectedType = 'controls';
    counterService.removeCallBacks();
    counterService.setCallBack(() => {
      for (let i = 0; i < this.models.items.length; i++) {
        this.setFieldName(this.models.items[i]);
      }
    });
    this.searchText = '';
    this.Util = Util;
  }
  $onInit = function() {
    if(this.showsection.components) {
      this.selectedType = 'components';
    }
  };
  onDragstart() {
    let selected = this.Util.returnSelected(this.selectedView.view.controls.A);
    if (selected.length) {
      for (let i = 0; i < selected.length; i++) {
        selected[i].selected = false;
      }
    }
  }

  setFieldName(item) {
    if (this.Util.controlsWithoutFieldName.indexOf(item.type) != -1 || this.counter[item.type] == undefined) {
      return;
    }

    let fieldName = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
    fieldName = fieldName.split('_');
    if (!isNaN(parseInt(fieldName[fieldName.length - 1]))) {
      fieldName.pop();
    }

    if (this.counter[item.type] == 0) {
      fieldName = `${fieldName.join('_')}`;
    } else {
      fieldName = `${fieldName.join('_')}_${this.counter[item.type]}`;
    }
    _.set(item, "properties.Basic['Field Name'].selectedValue", fieldName);
    _.set(item, "properties.Basic['Field Name'].prevSelectedValue", fieldName);
    if(item.properties && item.properties.Basic && item.properties.Basic['Data Field Name']) {
      _.set(item, "properties.Basic['Data Field Name'].selectedValue", fieldName);
      _.set(item, "properties.Basic['Data Field Name'].prevSelectedValue", fieldName);
    }
  }

  updateFieldName(item) {
    if (this.Util.controlsWithoutFieldName.indexOf(item.type) != -1) {
      return;
    }
    if (this.counter[item.type] == undefined) {
      this.counter[item.type] = 0;
    }
    
    this.counter[item.type]++;
    let fieldName = _.get(item, "properties.Basic['Field Name'].selectedValue", '');
    fieldName = fieldName.split('_');
    if (!isNaN(parseInt(fieldName[fieldName.length - 1]))) {
      fieldName.pop();
    }

    if (this.counter[item.type] == 0) {
      fieldName = `${fieldName.join('_')}`;
    } else {
      fieldName = `${fieldName.join('_')}_${this.counter[item.type]}`;
    }
    _.set(item, "properties.Basic['Field Name'].selectedValue", fieldName);
    _.set(item, "properties.Basic['Field Name'].prevSelectedValue", fieldName);
    if(item.properties && item.properties.Basic && item.properties.Basic['Data Field Name']) {
      _.set(item, "properties.Basic['Data Field Name'].selectedValue", fieldName);
      _.set(item, "properties.Basic['Data Field Name'].prevSelectedValue", fieldName);
    }
  }
}

export default angular.module('directives.toolbox', [])
  .component('toolbox', {
    template: require('./toolbox.html'),
    controller: ToolboxComponent,
    bindings: {
      opendialog:'&',
      showsection:'<'
    }
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/toolbox/toolbox.component.ts